export default __webpack_public_path__ + "static/forbrukslaan-dacc0967c9bdd2abad223caab7697ddc.png";